import React from 'react';
import { useIsMobile } from '../../../../utils/useIsMobile';
import './kpi.scss';
const Kpi = ({ kpi_data }) => {
  const { value, text, sub_text, sub_texts } = kpi_data || {};
  const isMobile = useIsMobile();
  const lines =
    sub_texts && sub_texts.length > 0 ? sub_texts : sub_text ? [sub_text] : [];
  return (
    <div
      className={`kpiHeader tw-box-border tw-min-h-32 tw-p-5 tw-rounded tw-bg-white ${isMobile ? 'tw-p-3' : 'tw-p-5'}`}
    >
      <div className={`${isMobile ? 'tw-font-bold' : 'bigValue tw-mb-2'}`}>
        {value != undefined ? value : ''}
      </div>
      <div className={`strongValue ${isMobile ? 'tw-mb-1' : ' tw-mb-2'}`}>
        {text ? text : 'Aucune donnée trouvé'}
      </div>
      {lines.map((line, i) => (
        <div key={i} className="lightValue">
          {line}
        </div>
      ))}
    </div>
  );
};

export default React.memo(Kpi);
